import MainMapas from '@/views/administracion/mapas/Main.vue';
import DefaultMapas from '@/views/administracion/mapas/Default.vue';

const auth = ['Consultas:ver'];
const scopes = ['Consultas:crear', 'Consultas:editar', 'Consultas:eliminar'];

const mapas = [
  {
    path: 'mapa',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: MainMapas,
    children: [
      {
        name: 'mapaObras',
        path: '/',
        meta: {
          title: 'Mapa de Obras',
          auth,
          scopes,
        },
        component: DefaultMapas,

        children: [],
      },
    ],
  },
];

export default mapas;
